export default "__VITE_ASSET__41a427b8__"